// extracted by mini-css-extract-plugin
export default {"heroContainer":"styles_heroContainer__fk6fw","textSection":"styles_textSection__INoO6","logoSection":"styles_logoSection__+yZV8","imageSection":"styles_imageSection__Z98Ot"};